import sessionReducers from "./sessionReducers";
import { combineReducers } from "redux";


const rootReducer = combineReducers({
    sessionReducers
});

export default rootReducer;
